module.exports = __webpack_public_path__ + "static/media/mr.9c95d546.svg";